var _style, _defs, _defs2, _g, _defs3, _defs4, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_3_);}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{clip-path:url(#SVGID_7_);}\r\n\t.st3{fill:#5596A4;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_1_",
    x1: 0,
    y1: 30,
    x2: 0,
    y2: 0
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_2_",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M106,31"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_6_",
    d: "M-4,31"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Steel",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st3",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    className: "st4",
    d: "M7.8,6.9H0.2C0.1,6.9,0,6.8-0.1,6.7l-3.8-6.5C-4,0-4-0.1-3.9-0.3l3.8-6.5C0-6.9,0.1-7,0.2-7h7.6 C8-7,8.1-6.9,8.2-6.8l3.8,6.5C12-0.1,12,0,11.9,0.1L8.2,6.7C8.1,6.8,8,6.9,7.8,6.9z M4-3.8c-2.1,0-3.7,1.7-3.7,3.7S1.9,3.7,4,3.7 S7.7,2,7.7-0.1S6.1-3.8,4-3.8z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.9,17.7c0-0.4-0.1-0.7-0.4-0.9s-0.8-0.4-1.5-0.7c-0.7-0.2-1.3-0.5-1.7-0.7c-1.1-0.6-1.7-1.4-1.7-2.5 c0-0.5,0.2-1,0.5-1.4s0.7-0.8,1.3-1s1.2-0.4,1.9-0.4c0.7,0,1.3,0.1,1.9,0.4s1,0.6,1.3,1.1s0.5,1,0.5,1.6h-2.1 c0-0.5-0.1-0.8-0.4-1.1s-0.7-0.4-1.2-0.4c-0.5,0-0.9,0.1-1.2,0.3s-0.4,0.5-0.4,0.8c0,0.3,0.2,0.6,0.5,0.8s0.8,0.4,1.4,0.6 c1.2,0.4,2,0.8,2.5,1.3c0.5,0.5,0.8,1.2,0.8,1.9c0,0.9-0.3,1.5-1,2s-1.5,0.7-2.6,0.7c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2 c-0.3-0.5-0.5-1.1-0.5-1.7h2.1c0,1.1,0.7,1.6,2,1.6c0.5,0,0.9-0.1,1.1-0.3S46.9,18,46.9,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.8,12h-3v8.3h-2.1V12h-3v-1.7h8.1V12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65,16h-3.9v2.7h4.6v1.6H59v-10h6.7V12h-4.6v2.4H65V16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.9,16h-3.9v2.7h4.6v1.6h-6.7v-10h6.7V12h-4.6v2.4h3.9V16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.8,18.7h4.4v1.6h-6.4v-10h2.1V18.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteel);
export default __webpack_public_path__ + "static/media/steel.d2a2334c588f12e459c5bac77bd65e54.svg";
export { ForwardRef as ReactComponent };